import { make } from 'vuex-pathify'
import axios from 'axios'
import { showError, showSuccess } from '@/util/helpers'

const state = {
  providers: [],
  mappings: {
    provider: null,
    supportedIntegratorMethods: [],
    mappings: [],
    paymentMethods: [],
  },
  loading: false,
  saving: false,
}

const mutations = make.mutations(state)

const actions = {
  getProviders: async ({ state }, companyId) => {
    state.loading = true
    const query = new URLSearchParams({ companyId }).toString()

    return axios
      .get(`${process.env.VUE_APP_API_URL}/payment-provider-config?${query}`)
      .then((res) => {
        state.providers = res.data || []
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  saveProviderConfig: async ({ state }, { provider, companyId, isActive, credentials, metadata, notify = true }) => {
    state.saving = true

    const buildRequestBody = () => {
      if (!['inter', 'sicoob'].includes(provider)) {
        return {
          companyId,
          isActive,
          credentials,
          metadata,
        }
      }

      const formData = new FormData()
      const {
        certificateFile,
        privateKeyFile,
        ...restCredentials
      } = credentials || {}

      formData.append('companyId', String(companyId))
      formData.append('isActive', String(!!isActive))
      formData.append('credentials', JSON.stringify(restCredentials || {}))
      formData.append('metadata', JSON.stringify(metadata || {}))

      if (certificateFile) {
        formData.append('certificateFile', certificateFile)
      }

      if (privateKeyFile) {
        formData.append('privateKeyFile', privateKeyFile)
      }

      return formData
    }

    return axios
      .put(`${process.env.VUE_APP_API_URL}/payment-provider-config/${provider}`, buildRequestBody())
      .then((res) => {
        if (notify) {
          showSuccess('Configuração salva com sucesso')
        }
        return res.data
      })
      .catch(showError)
      .finally(() => (state.saving = false))
  },

  getMappings: async ({ state }, { provider, companyId }) => {
    state.loading = true
    const query = new URLSearchParams({ provider, companyId }).toString()

    return axios
      .get(`${process.env.VUE_APP_API_URL}/payment-provider-mappings?${query}`)
      .then((res) => {
        state.mappings = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  saveMappings: async ({ state }, { provider, companyId, mappings, notify = true }) => {
    state.saving = true

    return axios
      .put(`${process.env.VUE_APP_API_URL}/payment-provider-mappings/${provider}`, {
        companyId,
        mappings,
      })
      .then((res) => {
        state.mappings = res.data
        if (notify) {
          showSuccess('Mapeamento salvo com sucesso')
        }
        return res.data
      })
      .catch(showError)
      .finally(() => (state.saving = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
